export default __webpack_public_path__ + "static/media/Sage-new-logo.95255131.svg";